import { ReactNode } from 'react'

import { Colors } from '@/constants/colors'

type ColorTagProps = {
  color?: string
  size?: 'sm' | 'md'
  children: ReactNode
}

export function ColorTag({ color, size, children }: ColorTagProps) {
  let textClasses = ''
  let bgClasses = ''

  switch (color) {
    case Colors.GREEN:
      textClasses = 'text-green-800'
      bgClasses = 'bg-green-100'
      break
    case Colors.BLUE:
      textClasses = 'text-blue-800'
      bgClasses = 'bg-blue-100'
      break
    case Colors.RED:
      textClasses = 'text-red-800'
      bgClasses = 'bg-red-100'
      break
    case Colors.YELLOW:
      textClasses = 'text-yellow-800'
      bgClasses = 'bg-yellow-100'
      break
    default:
      textClasses = 'text-gray-800'
      bgClasses = 'bg-gray-100'
  }

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 font-medium ${
        size === 'md' ? 'text-md' : 'text-xs'
      } ${textClasses} ${bgClasses}`}
    >
      {children}
    </span>
  )
}
